<template>
  <div
    class="card side-filter-card mb-3 p-custom-arrow p-custom-arrow-sidefilter"
  >
    <div class="card-body">
      <div class="row">
        <!-- Case Notes -->
        <div class="col-md-3">
           <!-- Search & Clear -->
          <div class="form-group mb-0">
            <button
              type="button"
              title="Search"
              class="btn p-0 text-body"
              @click="onSearch"
            >
              <span class="material-symbols-outlined fs-22 p-1 pl-0" style="color:#20478d">search</span>
            </button>

            <button
              type="button"
              title="Clear Filters"
              class="btn p-0 text-body"
              @click="clearFilters"
            >
              <span class="material-symbols-outlined fs-22 p-1 pl-0" style="color:#20478d"
                >filter_alt_off</span
              >
            </button>
          </div>
          <div class="form-group">
            <b-form-input
              v-model="filters.casenotes"
              placeholder="Search"
              aria-label="Case Notes"
              aria-labelledby="Case Notes"
              type="text"
              name="casenotes"
              size="sm"
            />
          </div>
        </div>

        <!-- Region -->
        <div class="col-md-3">
          <div class="form-group">
            <label>Geographic Region</label>
            <p-dropdown
              v-model="filters.region"
              :options="regions"
              optionLabel="name"
              optionValue="id"
              placeholder="All"
              class="p-dropdown-custom form-control form-control-sm"
              aria-label="Region"
              aria-labelledby="Region"
              @change="onRegionChange"
            />
          </div>
        </div>

        <!-- Country -->
        <div class="col-md-3">
          <div class="form-group">
            <label>Country</label>
            <p-dropdown
              v-model="filters.country"
              :options="countryList"
              optionLabel="country"
              optionValue="country"
              placeholder="All"
              :disabled="!filters.region"
              class="p-dropdown-custom form-control form-control-sm"
              aria-label="Country"
              aria-labelledby="Country"
            />
          </div>
        </div>
        <!-- Age -->
        <div class="col-md-3">
          <div class="form-group">
            <label>Age (years)</label>
            <p-dropdown
              v-model="filters.age"
              :options="ageRangeList"
              optionLabel="value"
              optionValue="id"
              placeholder="All"
              class="p-dropdown-custom form-control form-control-sm"
              aria-label="Age"
              aria-labelledby="Age"
            />
          </div>
        </div>

        <!-- Gender -->
        <div class="col-md-3">
          <div class="form-group">
            <label>Gender</label>
            <p-dropdown
              v-model="filters.gender"
              :options="genderList"
              optionLabel="value"
              optionValue="value"
              placeholder="All"
              class="p-dropdown-custom form-control form-control-sm"
              aria-label="Gender"
              aria-labelledby="Gender"
            />
          </div>
        </div>

        <!-- Familial -->
        <div class="col-md-3">
          <div class="form-group">
            <label>Familial Disease</label>
            <p-dropdown
              v-model="filters.familialDisease"
              :options="familialDisease"
              optionLabel="name"
              optionValue="id"
              placeholder="All"
              class="p-dropdown-custom form-control form-control-sm"
              aria-label="Familial Disease"
              aria-labelledby="Familial Disease"
            />
          </div>
        </div>

        <!-- Environmental -->
        <div class="col-md-3">
          <div class="form-group">
            <label>Environmental Setting</label>
            <p-dropdown
              v-model="filters.environmentalSettings"
              :options="environmentalSettings"
              optionLabel="name"
              optionValue="id"
              placeholder="All"
              class="p-dropdown-custom form-control form-control-sm"
              aria-label="Environmental Setting"
              aria-labelledby="Environmental Setting"
            />
          </div>
        </div>

        <!-- Specific Cohort -->
        <div class="col-md-3">
          <div class="form-group">
            <label>Specific Cohort</label>
            <p-dropdown
              v-model="filters.specificCohortId"
              :options="cohorts"
              optionLabel="name"
              optionValue="id"
              placeholder="All"
              class="p-dropdown-custom form-control form-control-sm"
              aria-label="Specific Cohort"
              aria-labelledby="Specific Cohort"
            />
          </div>
        </div>

        <!-- Tumor Type -->
        <div class="col-md-3">
          <div class="form-group cus-placeholder">
            <label>Tumor Type</label>
            <el-select
              id="tumorType"
              :aria-label="$t('common.tumorType')"
              :aria-labelledby="$t('common.tumorType')"
              :placeholder="$t('common.tumorType')"
              :title="`Select Tumor Type`"
              class="w-100"
              v-model="filters.tumorType"
              filterable
              @change="onTumorTypeChange"
            >
              <!-- All option -->
              <el-option :value="''" label="All"></el-option>

              <!-- Grouped options -->
              <el-option-group
                v-for="group in tumorTypes"
                :key="group.label"
                :label="group.label"
              >
                <el-option
                  v-for="item in group.items"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-option-group>
            </el-select>
          </div>
        </div>

        <!-- Tumor Subtype -->
        <div class="col-md-3">
          <div class="form-group">
            <label>Tumor Subtype</label>
            <p-dropdown
              id="tumorSubType"
              :aria-label="$t('common.tumorSubType')"
              :aria-labelledby="$t('common.tumorSubType')"
              :placeholder="$t('common.tumorSubType')"
              :title="`Select Tumor Subtype`"
              class="p-dropdown-custom form-control form-control-sm w-100"
              optionLabel="name"
              optionValue="id"
              v-model="filters.tumorSubType"
              :options="[{ id: '', name: 'All' }, ...tumorSubTypes]"
            >
            </p-dropdown>
          </div>
        </div>

     

        <!-- Add Manual -->
        <div class="col-md-3" style="margin-top: 32px">
          <div class="form-group">
            <button
              type="button"
              class="btn btn-primary"
              @click="$emit('addmanual')"
            >
              Add selected cases to {{ type === 'Collection' ? 'collection' : 'assignment' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Country from "../../../models/model-countries.js";
import ageList from "../../../models/model-age-range.js";
import gendersList from "../../../models/model-gender.js";
import { orderBy, cloneDeep } from "lodash";
export default {
  name: "manual-case-filter",
  props: {
    totalCases: { type: Number, default: 0 },
    type:String
  },
  data() {
    return {
      filters: {
        casenotes: "",
        region: "",
        country: "",
        age: [],
        gender: "",
        familialDisease: "",
        environmentalSettings: "",
        specificCohortId: "",
        tumorType: "",
        tumorSubType: "",
      },
      regions: [],
      countryList: [],
      ageRangeList: cloneDeep(ageList),
      genderList: cloneDeep(gendersList),
      familialDisease: [],
      environmentalSettings: [],
      cohorts: [],
      tumorTypes: [],
      tumorSubTypes: [],
      previewMode: true,
    };
  },
  methods: {
    async fetchRegions() {
      const res = await this.$api.getAllGeographicregionsFact();
      this.regions = res.data.payload || [];
    },
    async fetchCohorts() {
      const res = await this.$api.getAllSpecificCohortsFact();
      const excluded = ["Iodine-deficiency", "NIFTP study", "HTT study"];
      this.cohorts = orderBy(
        res.data.payload.filter((item) => !excluded.includes(item.name)),
        ["name"],
        ["asc"]
      );
    },
    async fetchFamilial() {
      const res = await this.$api.getAllFamilialDiseaseFact(1);
      this.familialDisease = res.data.payload.filter((t) => t.parentId == null);
    },
    async fetchEnvironment() {
      const res = await this.$api.getAllEnvironmentalSettingFact(1);
      this.environmentalSettings = res.data.payload.filter(
        (t) => t.parentId == null
      );
    },
    async fetchTumorTypes() {
      const res = await this.$api.getAllTumortypesFact(1);
      const types = orderBy(res.data.payload, ["name"], ["asc"]);
      this.tumorTypes = this.groupedTumorTypes(types);
    },
    async fetchTumorSubTypes(typeId) {
      const res = await this.$api.getAllTumorSubTypesFact(typeId);
      this.tumorSubTypes = orderBy(res.data.payload, ["name"], ["asc"]);
    },
    groupedTumorTypes(types) {
      const groups = {};
      types.forEach((t) => {
        let g = "Non-neoplastic";
        if (t.tumorTypeCategoryId === 1) g = "Common";
        else if (t.tumorTypeCategoryId === 2) g = "Uncommon";
        if (!groups[g]) groups[g] = [];
        groups[g].push(t);
      });
      const order = ["Common", "Uncommon", "Non-neoplastic"];
      return order
        .filter((g) => groups[g])
        .map((g) => ({ label: g, items: groups[g] }));
    },
    onRegionChange() {
      this.countryList = Country.filter(
        (c) => c.regionId === Number(this.filters.region)
      );
      this.filters.country = "";
    },
    onTumorTypeChange() {
      if (this.filters.tumorType) {
        this.fetchTumorSubTypes(this.filters.tumorType);
      } else {
        this.tumorSubTypes = [];
      }
      this.filters.tumorSubType = "";
    },
    convertAgeToRange(ageId) {
      if (!ageId) return null;

      // Convert ageId to number for comparison
      const numericAgeId = Number(ageId);
      const ageItem = this.ageRangeList.find(
        (item) => item.id === numericAgeId
      );

      if (!ageItem) return null;

      const ageString = ageItem.value;
      const updatedAge = [0, 0];

      // Extract all numbers from the age string
      const numbers = ageString.match(/\d+/g)?.map(Number) || [];

      if (numericAgeId === 1) {
        // "Under 1"
        updatedAge[0] = 0;
        updatedAge[1] = 0; // Under 1 year old
      } else if (numericAgeId === 5) {
        // "Over 65"
        updatedAge[0] = 66; // Over 65 means 66 and above
        updatedAge[1] = 120; // Reasonable maximum age
      } else {
        // For ranges like "1 to 5", "6 to 19", "21 to 65"
        if (numbers.length >= 2) {
          updatedAge[0] = numbers[0];
          updatedAge[1] = numbers[1];
        } else if (numbers.length === 1) {
          // Fallback if only one number is found
          updatedAge[0] = numbers[0];
          updatedAge[1] = numbers[0];
        }
      }

      return updatedAge;
    },
    onSearch() {
      const searchFilters = { ...this.filters, gridType: this.previewMode };

      // Convert age ID to range format
      searchFilters.age = this.convertAgeToRange(searchFilters.age);
      // For environmentalSettings, we need to pass the object, not the ID
      if (searchFilters.environmentalSettings) {
        searchFilters.environmentalSettings =
          this.environmentalSettings.find(
            (env) => env.id === searchFilters.environmentalSettings
          ) || null;
      } else {
        searchFilters.environmentalSettings = null;
      }
      // For familialDisease, we need to pass the object, not the ID
      if (searchFilters.familialDisease) {
        searchFilters.familialDisease =
          this.familialDisease.find(
            (fam) => fam.id === searchFilters.familialDisease
          ) || null;
      } else {
        searchFilters.familialDisease = null;
      }
      console.log(searchFilters)
      this.$emit("search", { ...searchFilters, gridType: this.previewMode });
    },
    clearFilters() {
      Object.keys(this.filters).forEach((k) => (this.filters[k] = ""));
      this.countryList = [];
      this.tumorSubTypes = [];
      this.$emit("clear");
    },
    changeGridMode(type) {
      this.previewMode = type;
      this.$emit("gridMode", type);
    },
  },
  mounted() {
    this.fetchRegions();
    this.fetchCohorts(1);
    this.fetchFamilial();
    this.fetchEnvironment();
    this.fetchTumorTypes();
  },
};
</script>
<style>
.cus-placeholder #tumorType {
  height: calc(1.9em + 0.438rem + 0px);
  padding: 0.15rem 0.5rem;
}
</style>
